import script from "./LanguagePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./LanguagePicker.vue?vue&type=script&lang=ts&setup=true"

import "./LanguagePicker.vue?vue&type=style&index=0&id=506e1238&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-506e1238"]])

export default __exports__